export interface IWhitelabelRedirect {
  // absolute path that should no longer render its own page
  from: string;
  // absolute path to redirect to
  to: string;
}

// Instance specific redirects, fixed at build time. They take precedence over every other route,
// so only the exact paths listed here are affected — everything else routes as usual.
// Empty here by design: the base instance has none, whitelabel forks fill this list.
// Example: { from: `${FRONTEND_PROFILE_FEED_PATH}/press/some-profile`, to: `${INFRASTRUCTURE_PROJECTS_PARTIAL}/some-project` }
export const WHITELABEL_REDIRECTS: IWhitelabelRedirect[] = []
